"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultXAxisFormat = exports.TOOLTIP_FORMATS = exports.VALUE_FORMATS = exports.annotationFormat = exports.getSISuffix = exports.truncateSingle = exports.suffixes = void 0;
const d3 = __importStar(require("d3"));
const lodash_1 = __importDefault(require("lodash"));
const date_1 = require("./date");
const AXIS_MONTH_LONG_BREAKPOINT = 400;
exports.suffixes = {
  [undefined]: {
    long: '',
    short: ''
  },
  k: {
    long: ' thousand',
    short: 'K'
  },
  M: {
    long: ' million',
    short: 'M'
  },
  G: {
    long: ' billion',
    short: 'B'
  },
  T: {
    long: ' trillion',
    short: 'T'
  },
  P: {
    long: ' quadrillion',
    short: 'Q'
  }
};
const getUniqueSmallDecimals = ticks => {
  const tickParts = ticks.map(t => ({
    number: t.toPrecision(12).split('.')[1],
    sign: Math.sign(t) < 0 ? '-' : ''
  }));
  let decimals = 1;
  let uniqueValues = [];
  while (uniqueValues.length !== ticks.length) {
    decimals += 1;
    if (decimals > 12) return null;
    uniqueValues = lodash_1.default.uniqBy(tickParts,
    // eslint-disable-next-line no-loop-func
    _ref => {
      let {
        number,
        sign
      } = _ref;
      return `${sign}${number.slice(0, decimals)}`;
    });
  }
  return decimals;
};
const getVerySmallDecimal = function (n) {
  let sigDecimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  if (Number(n) === 0 || n === undefined) return 0;
  return String(n).match(/\.(?<zeros>0+)/).groups.zeros.length + sigDecimals;
};
const getDecimal = n => {
  const absN = Math.abs(n);
  if (Number.isInteger(absN)) {
    return 0;
  }
  if (absN < 0.01) {
    return getVerySmallDecimal(absN, 2);
  }
  if (absN < 1) {
    return 2;
  }
  return 1;
};
const getPercentDecimal = n => {
  const absN = Math.abs(n * 10);
  if (absN < 0.1) {
    return 2;
  }
  if (absN < 1) {
    return 1;
  }
  if (absN >= 1) {
    return 0;
  }
  return 1;
};
const getDollarDecimal = n => {
  const absN = Math.abs(n);
  if (Number.isInteger(absN)) {
    return 0;
  }
  if (absN < 100) {
    return 2;
  }
  return getDecimal(absN);
};
const decimalGetters = {
  [undefined]: getDecimal,
  percent: getPercentDecimal,
  dollars: getDollarDecimal
};
const truncateSingle = n => {
  let shortN = Math.abs(n);
  let divides = 0;
  const sign = n < 0 ? -1 : 1;
  while (shortN >= 1000) {
    shortN /= 1000;
    divides += 1;
  }
  return {
    value: sign * shortN,
    divides
  };
};
exports.truncateSingle = truncateSingle;
const truncateList = arr => {
  let shortArr = arr;
  let divides = 0;
  while (shortArr.some(n => Math.abs(n) >= 1000)) {
    shortArr = shortArr.map(n => Math.abs(n) / 1000);
    divides += 1;
  }
  return {
    ticks: shortArr,
    divides
  };
};
const getConsistentDecimal = (options, type) => {
  if (!lodash_1.default.isNil(options.decimals)) {
    return {
      decimals: options.decimals,
      divides: null
    };
  }
  if (!options.ticks) {
    return {
      decimals: null,
      divides: 0
    };
  }
  const {
    ticks,
    divides
  } = truncateList(options.ticks);
  const scaledTicks = type === 'percent' ? ticks.map(d => d * 100) : ticks;
  let decimals = 0;
  const diffBetweenTicks = Math.abs(scaledTicks[1] - scaledTicks[0]);
  if (diffBetweenTicks < 1) {
    if (type === 'dollars') {
      decimals = 2;
    } else {
      decimals = 1;
    }
  }
  if (diffBetweenTicks < 0.1) {
    decimals = 2;
  }
  if (diffBetweenTicks < 0.01) {
    if (options.autoSmallDecimals) {
      const unique = getUniqueSmallDecimals(ticks);
      if (Number.isFinite(unique)) {
        decimals = unique;
        if (type === 'percent') {
          decimals -= 2;
        }
      }
    } else {
      decimals = Math.max(...scaledTicks.map(t => {
        // toPrecision(~12) removes floating point error
        const digitsFixed = t.toPrecision(12);
        const digitsAfterDecimal = digitsFixed.match(/\..*/);
        if (!digitsAfterDecimal) {
          return 0;
        }
        // remove trailing zeros and return decimal length
        return digitsAfterDecimal[0].replace(/0+$/, '').length - 1;
      }));
    }
  }
  if (diffBetweenTicks === 0) {
    decimals = 2;
  }
  return {
    decimals,
    divides
  };
};
const getSISuffix = function (n) {
  let siMult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  const siSize = d3.format('s')(n * siMult).match(/[a-zA-Z]+|[0-9]+(?:\.[0-9]+)?|\.[0-9]+/g);
  return Math.abs(n) > 1 ? siSize[1] : undefined;
};
exports.getSISuffix = getSISuffix;
const roundedFormat = function (n) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    suffixLength,
    type,
    truncate
  } = options;
  let shortN = (0, exports.truncateSingle)(n).value;
  if (!truncate) {
    if (Math.abs(n) < 1000) {
      const decimals = decimalGetters[type](shortN);
      return n.toFixed(decimals);
    }
    return d3.format(',d')(Math.round(n));
  }
  if (options.ticks && n === 0) {
    return 0;
  }
  let {
    decimals,
    divides
  } = getConsistentDecimal(options, type);
  if (divides === null) {
    divides = (0, exports.truncateSingle)(n).divides;
  }
  let siMult = 1;
  if (decimals === null) {
    // truncate single value ourselves
    decimals = decimalGetters[type](shortN);
  } else {
    // get same divided value as in getConsistentDecimal
    const listShortN = n / 1000 ** divides;
    siMult = shortN / listShortN;
    shortN = listShortN;
  }
  const suffix = (0, exports.getSISuffix)(n, siMult);
  return `${shortN.toFixed(decimals)}${exports.suffixes[suffix][suffixLength || 'short']}`;
};
const annotationFormat = function (value) {
  let {
    values = [value],
    type = ''
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const hasSmallValue = lodash_1.default.some(values, v => Math.abs(v.value) < 1000);
  const formatLocale = d3.formatLocale({
    minus: '-',
    currency: ['$', '']
  });
  const fixedFormat = formatLocale.format(',.2f');
  if (type.toLowerCase() === 'percent') {
    return `${parseFloat(fixedFormat(value * 100))}%`;
  }
  if (type.toLowerCase() === 'dollars') {
    return hasSmallValue && Math.abs(value) < 10000 ? formatLocale.format('$')(fixedFormat(value)) : `${formatLocale.format('$')(parseFloat(fixedFormat((0, exports.truncateSingle)(value).value)))}${exports.suffixes[(0, exports.getSISuffix)(value)].short}`;
  }
  return hasSmallValue && Math.abs(value) < 10000 ? parseFloat(fixedFormat(value)) : `${parseFloat(fixedFormat((0, exports.truncateSingle)(value).value))}${exports.suffixes[(0, exports.getSISuffix)(value)].short}`;
};
exports.annotationFormat = annotationFormat;
function localDateFormat(date, type) {
  try {
    const parsed = date instanceof Date ? date : (0, date_1.dateParser)(date, type);
    return (0, date_1.dateFormat)(parsed, type);
  } catch (err) {
    throw new Error(`Date ${date} is invalid`);
  }
}
const formatUnformatted = n => n;
const formatLinear = function (n) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return roundedFormat(n, {
    truncate: true,
    ...options
  });
};
const formatPercent = function (n) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let {
    decimals
  } = getConsistentDecimal(options, 'percent');
  if (decimals === null) {
    decimals = getPercentDecimal(n);
  }
  if (n === 0) {
    decimals = 0;
  }
  return `${((n + Number.EPSILON) * 100).toFixed(decimals)}%`;
};
const formatDollars = (n, options) => `${n < 0 ? '-' : ''}$${roundedFormat(Math.abs(n), {
  truncate: true,
  ...options,
  type: 'dollars'
})}`;
const DATE_FORMATS = ['years', 'yearly', 'monthsfull', 'monthlyfull', 'months', 'monthly', 'quarters', 'quarterly', 'weeks', 'weekly', 'days', 'daily', 'daysfull', 'dailyfull'].reduce((obj, d) => ({
  ...obj,
  [d]: function (n) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return localDateFormat(n, d, options);
  }
}), {});
exports.VALUE_FORMATS = {
  items: formatUnformatted,
  unformatted: formatUnformatted,
  default: formatLinear,
  linear: formatLinear,
  percent: formatPercent,
  dollars: formatDollars,
  ...DATE_FORMATS
};
const getTooltipPercentDecimal = () => 2;
const formatTooltipLinear = function (n) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return roundedFormat(n, {
    truncate: false,
    ...options
  });
};
const formatTooltopPercent = function (n) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let {
    decimals
  } = getConsistentDecimal(options, 'percent');
  if (decimals === null) {
    decimals = getTooltipPercentDecimal(n);
  }
  // fix floating point
  const rounded = ((n + Number.EPSILON) * 100).toFixed(decimals).replace(/(\..)0+$/, '$1');
  // strip trailing zeros after decimal, then strip decimal if no decimals left
  return `${rounded.replace(/(\.[^0]*)0+$/, '$1').replace(/\.$/, '')}%`;
};
exports.TOOLTIP_FORMATS = {
  default: formatTooltipLinear,
  percent: formatTooltopPercent,
  dollars: formatDollars
};
const defaultXAxisFormat = (date, width) => {
  let formatString = '%Y'; // Full yeah, 1999
  if (d3.utcMonth(date) < date) {
    formatString = '%_d'; // space padded day of the month, 1
  } else if (d3.utcYear(date) < date) {
    if (Number(width) && Number(width) > AXIS_MONTH_LONG_BREAKPOINT) {
      formatString = '%B'; // full month name, January
    } else {
      formatString = '%b'; // abrv. month name, Jan
    }
  }

  return d3.utcFormat(formatString)(date);
};
exports.defaultXAxisFormat = defaultXAxisFormat;